/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFieldFilterModule } from 'src/app/common/custom-field-filter/components/custom-field-filter.module';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { MaterialModule } from 'src/app/common/material/material-module';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { ReportFooterComponent } from './components/report-footer/report-footer.component';
import { ReportsComponent } from './components/report/reports.component';
import { TPFilterComponent } from 'src/app/common/tp-filter/tp-filter.component';
import { AutomationIdDirective } from 'src/app/shared/directives/automation-id/automation-id.directive';

@NgModule({
	declarations: [ReportsComponent, ReportFooterComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		DialogReusableModule,
		SharedUIMaterialModule,
		PresentationModule,
		CustomFieldFilterModule,
		TPFilterComponent,
		AutomationIdDirective,
	],
	exports: [ReportsComponent, ReportFooterComponent, TPFilterComponent],
	providers: [],
})
export class ReportsModule {}
